import { render, staticRenderFns } from "./borrowedPatternTable.vue?vue&type=template&id=23e0c658"
import script from "./borrowedPatternTable.vue?vue&type=script&lang=js"
export * from "./borrowedPatternTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports